import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

/**
 * Saves (Create or Update) a restaurant dish
 */
export default {
  url(payload) {
    const { id, action = 'create' } = payload || {}
    if (action === 'update' && id) {
      return buildApiUrl(ADMIN_ENDPOINTS.DISH_BY_ID, { pathParams: { id } })
    }
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DISHES)
  },

  method(payload) {
    const { action = 'create' } = payload || {}
    return action === 'update' ? 'PUT' : 'POST'
  },

  format(payload) {
    const { 
      title, 
      name,
      description, 
      price, 
      category, 
      categoryId,
      subcategory,
      subcategoryId,
      image,
      principalImageUrl,
      images,
      options, 
      cookDurationInMin,
      storeId,
      restaurantId,
      storeName,
      restaurantName,
      accompaniments,
      accompaniements
    } = payload || {}

    return {
      title: title || name,
      description,
      price: Number(price),
      category: category || '',
      categoryId: categoryId || '',
      subcategory: subcategory || '',
      subcategoryId: subcategoryId || '',
      principalImageUrl: principalImageUrl || image,
      images: images || [],
      options: options || [],
      cookDurationInMin: Number(cookDurationInMin) || 0,
      storeId: storeId || restaurantId,
      storeName: storeName || restaurantName || '',
      accompaniments: accompaniments || accompaniements || []
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return { 
        statusCode: raw?.statusCode || 400, 
        message: raw?.message || 'Erreur lors de l\'opération', 
        data: null 
      }
    }
    return { 
      statusCode: 200, 
      message: 'Opération réussie', 
      data: raw.data 
    }
  },
}
